import dynamic from 'next/dynamic';
import React from 'react';

import { Modal } from '~components/Modals/Base';
import type { TModalProps } from '~components/Modals/types';
import type { AuthSuccessCallbackType } from '~context/auth/types';
import type { RegisterAnalytics } from '~features/annals';

const Content = dynamic(
	() => import('./dynamicContent').then((mod) => mod.Content),
	{
		ssr: false,
	}
);

type Props = TModalProps & {
	onLoginClick: () => void;
	onSuccess: (str: AuthSuccessCallbackType) => void;
	analytics: RegisterAnalytics;
};

export const RegisterModal = ({
	open,
	locked,
	analytics,
	onClose,
	onLoginClick,
	onSuccess,
}: Props) => {
	return (
		<Modal open={open} locked={locked} onClose={onClose}>
			<Content
				open={open}
				locked={locked}
				analytics={analytics}
				onClose={onClose}
				onLoginClick={onLoginClick}
				onSuccess={onSuccess}
			/>
		</Modal>
	);
};
